var _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "settings-circle-mask"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M60 60c-80 79-80 208 0 287 79 79 208 79 287 0s79-208 0-287c-79-80-208-80-287 0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(216 216) scale(0.55) translate(-216 -216)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M8 363c-4 0-7-3-7-7 0-5 3-8 7-8h132c4 0 7 3 7 8 0 4-3 7-7 7H8zm208 0c-4 0-8-3-8-7 0-5 4-8 8-8h182c4 0 7 3 7 8 0 4-3 7-7 7H216zM8 211c-4 0-7-4-7-8s3-7 7-7h259c4 0 7 3 7 7s-3 8-7 8H8zm335 0c-4 0-8-4-8-8s4-7 8-7h55c4 0 7 3 7 7s-3 8-7 8h-55zM8 58c-4 0-7-3-7-7s3-8 7-8h63c4 0 7 4 7 8s-3 7-7 7H8zm139 0c-4 0-8-3-8-7s4-8 8-8h251c4 0 7 4 7 8s-3 7-7 7H147z M178 310c12 0 24 5 32 13 8 9 13 20 13 33 0 12-5 24-13 32s-20 13-32 13c-13 0-24-5-32-13-9-8-14-20-14-32 0-13 5-24 14-33 8-8 19-13 32-13zm21 24c-5-6-13-9-21-9-9 0-16 3-22 9-5 5-9 13-9 22 0 8 4 16 9 21 6 6 13 9 22 9 8 0 16-3 21-9 6-5 9-13 9-21 0-9-3-17-9-22zm106-176c12 0 24 5 32 13s13 20 13 32c0 13-5 24-13 32-8 9-20 14-32 14-13 0-24-5-32-14-9-8-14-19-14-32 0-12 5-24 14-32 8-8 19-13 32-13zm21 24c-5-6-13-9-21-9-9 0-16 3-22 9-5 5-9 13-9 21 0 9 4 16 9 22 6 5 13 9 22 9 8 0 16-4 21-9 6-6 9-13 9-22 0-8-3-16-9-21zM109 5c12 0 24 5 32 14 8 8 13 19 13 32 0 12-5 24-13 32s-20 13-32 13c-13 0-24-5-33-13-8-8-13-20-13-32 0-13 5-24 13-32 9-9 20-14 33-14zm21 24c-5-5-13-9-21-9-9 0-16 4-22 9-5 6-9 13-9 22 0 8 4 16 9 21 6 6 13 9 22 9 8 0 16-3 21-9 6-5 9-13 9-21 0-9-3-16-9-22z"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 432,
    fill: "currentColor",
    mask: "url(#settings-circle-mask)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsCircleFilled);
export default __webpack_public_path__ + "static/media/SettingsCircleFilled.82c89fb33a3d9f1992c012a5a1800b64.svg";
export { ForwardRef as ReactComponent };